export default __webpack_public_path__ + "static/media/reading-unicorn.f34d65b9.svg";